export enum OrderIdentifier {
    KOKO = "Koko Order ID",
    // SHOPIFY = "Shopify Order ID", // TODO
    ONLINE = "Online Order ID",
    MERCHANT_REFERENCE = "Merchant Reference Code"
  }